/* eslint-disable no-underscore-dangle */

export const promStringifyWithName = (name: string, labels: Record<string, string>): string => {
  const labelStr = Object.entries(labels)
    .map(([key, val]) => `${key}="${val}"`)
    .join(',');
  return labelStr === '' ? `${name}` : `${name}{${labelStr}}`;
};

export const promStringify = (labels: Record<string, string>): string => {
  const labelsClone = { ...labels };
  delete labelsClone.__name__;
  const name = labels.__name__ || '';

  return promStringifyWithName(name, labelsClone);
};
